
























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import TreeSelect from "@riophae/vue-treeselect";
import MessageConfigPO from "@/store/entities/messageinfo/messageconfigpo";
import MessageConfigDetailPO from "@/store/entities/messageinfo/messageconfigdetailpo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

@Component({
  components: { TreeSelect },
})
export default class CreateMessageConfig extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  entity: MessageConfigPO = new MessageConfigPO();
  isAble: boolean = true;
  detailPO = new MessageConfigDetailPO();
  smsconfigdata: any[] = [];
  columnsdata: any[] = [];
  loading: boolean = false;

  async created() {
    await this.getsmsConfig();
    await this.getOrganizations();
    await this.getWaringTypeList();
  }
  //获取组织
  async getOrganizations() {
    await this.$store
      .dispatch("organization/getCommanySelectTree")
      .then((val) => {
        this.$data.organizations = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //告警信息类型
  async getWaringTypeList() {
    await this.$store
      .dispatch("messageconfigdetail/getWaringTypeList")
      .then((val) => {
        this.columnsdata = val;
        this.entity.detail = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //获取配置模板
  async getsmsConfig() {
    await this.$store
      .dispatch("smsconfig/getSMSConfigList")
      .then((val) => {
        val.forEach((ele) => {
          this.smsconfigdata.push({
            label: ele.name,
            value: ele.id,
          });
        });
        //console.log(this.smsconfigdata);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //正常列
  columnlist = [
    {
      title: this.L("Name"),
      key: "waringName",
      align: "center",
    },
    {
      title: this.L("SMSConfig"),
      key: "smsConfigId",
      align: "center",
      render: (h: any, params: any) => {
        let that = this;
        return h(
          "Select",
          {
            props: {
              value: params.row.smsConfigId, //绑定数据
              transfer: true, //不受表格高度影响
            },
            on: {
              "on-change": (event) => {
                that.entity.detail[params.index].smsConfigId = event;
              },
            },
          },
          this.smsconfigdata.map((val) => {
            return h("Option", {
              props: { value: val.value, label: val.label },
            });
          })
        );
      },
    },
    {
      title: this.L("IsSMS"),
      key: "isSMS",
      align: "center",
      render: (h: any, params: any) => {
        let that = this;
        return h("Checkbox", {
          props: {
            value: params.row.isSMS,
          },
          domProps: {
            value: params.row.isSMS,
          },
          on: {
            "on-change": (event) => {
              that.entity.detail[params.index].isSMS = event;
            },
          },
        });
      },
    },
    {
      title: this.L("IsMiniApp"),
      key: "isMiniApp",
      align: "center",
      render: (h: any, params: any) => {
        let that = this;
        return h("Checkbox", {
          props: {
            value: params.row.isMiniApp,
          },
          domProps: {
            value: params.row.isMiniApp,
          },
          on: {
            "on-change": (event) => {
              that.entity.detail[params.index].isMiniApp = event;
            },
          },
        });
      },
    },
    {
      title: this.L("IsMail"),
      key: "isMail",
      align: "center",
      render: (h: any, params: any) => {
        let that = this;
        return h("Checkbox", {
          props: {
            value: params.row.isMail,
          },
          domProps: {
            value: params.row.isMail,
          },
          on: {
            on: {
              "on-change": (event) => {
                that.entity.detail[params.index].isMail = event;
              },
            },
          },
        });
      },
    },
  ];
  create() { }

  save() {
    (this.$refs.priceForm as any).validate(async (valid: boolean) => {
      if (valid) {
        console.log(this.entity)
        let mailsend = false;
        let mobil = false;
        this.entity.detail.forEach((ele) => {
          if (ele.waringTypeId != 62 && ele.isMail) {
            mailsend = true;
          }
          if (ele.waringTypeId != 62 && (ele.isMiniApp || ele.isSMS)) {
            mobil = true;
          }
          if (mailsend && mobil) {
            return;
          }
        })
        if (mailsend && this.entity.isGroup == false && (this.entity.targetMail == "" || this.entity.targetMail == null)) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L('MailSendNoMail'),
          });
          return;
        }
        if (mobil && this.entity.isGroup == false && (this.entity.targetMobile == "" || this.entity.targetMobile == null)) {
          this.$Modal.warning({
            title: this.L("Tips"),
            content: this.L('MobileSendNoMobile'),
          });
          return;
        }
        this.loading
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "messageconfig/create",
            data: this.entity,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        if (res.isSuccess) {
          (this.$refs.priceForm as any).resetFields();
          this.$emit("save-success");
          this.$emit("input", false);
        } else {
          this.$Modal.info({
            title: this.L("Tips"),
            content: res.result,
          });
        }
        this.loading = false;
      }
    });
  }
  cancel() {
    (this.$refs.priceForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  ruleValidate = {
    name: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    organizationId: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      organizations: [], //组织
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
